import { useState } from "react";
import { campInformation, packingInformation } from "../utils/CampInformation";
import { isRegistrationOpen } from "../utils/registration";

const PACKED_KEY = "hsyc-packed-items";

const readPacked = () => {
  try {
    return JSON.parse(localStorage.getItem(PACKED_KEY)) || [];
  } catch (e) {
    return [];
  }
};

function PackingItem({ item, packed, onToggle }) {
  return (
    <li>
      <label className="hsyc-check">
        <input
          type="checkbox"
          checked={packed.includes(item)}
          onChange={() => onToggle(item)}
        />
        <span>{item}</span>
      </label>
    </li>
  );
}

export default function CampInformationSection({ section_name }) {
  const camp = campInformation[section_name];
  const [packed, setPacked] = useState(readPacked);

  const togglePacked = (item) => {
    const next = packed.includes(item)
      ? packed.filter((p) => p !== item)
      : [...packed, item];
    setPacked(next);
    try {
      localStorage.setItem(PACKED_KEY, JSON.stringify(next));
    } catch (e) {}
  };

  return (
    <>
      <section className="hsyc-section" id={camp.id}>
        <div className="hsyc-wrap hsyc-details">
          <div className="hsyc-details__intro">
            <h2>{camp.camp_title}</h2>
            <p>
              This year's theme is the {camp.theme}. {camp.description}
            </p>
            {isRegistrationOpen() && (
              <a className="hsyc-button" href={camp.registration_link}>
                Register for winter camp
              </a>
            )}
          </div>
          <dl className="hsyc-facts">
            {camp.informational_blobs.map((item) => (
              <div className="hsyc-facts__row" key={item.title}>
                <dt>{item.title}</dt>
                <dd>{item.data}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      <section className="hsyc-section hsyc-packing" id="packing-list">
        <div className="hsyc-wrap">
          <h2>What to pack</h2>
          <p className="hsyc-packing__lead">
            Tick items off as you pack. Your list is saved on this device.
          </p>
          <div className="hsyc-packing__lists">
            <div>
              <h3>Bring</h3>
              <ul>
                {packingInformation.General.map((item) => (
                  <PackingItem
                    key={item}
                    item={item}
                    packed={packed}
                    onToggle={togglePacked}
                  />
                ))}
              </ul>
            </div>
            <div>
              <h3>Nice to have</h3>
              <ul>
                {packingInformation.Optional.map((item) => (
                  <PackingItem
                    key={item}
                    item={item}
                    packed={packed}
                    onToggle={togglePacked}
                  />
                ))}
              </ul>
            </div>
          </div>
          <p className="hsyc-packing__note">
            Flying in from out of state? Let us know if you need us to provide
            bedding.
          </p>
        </div>
      </section>
    </>
  );
}
